import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createSOCSample } from '../../services/farmMapping/socSamples/createSOCSamples'
import { getSOCSamples } from '../../services/farmMapping/socSamples/getSOCSamples'
import { removeSOCSample } from '../../services/farmMapping/socSamples/removeSOCSamples'
import { updateSOCSample } from '../../services/farmMapping/socSamples/updateSOCSamples'
import { queryKeys } from './queryKeys'

export const useSOCSamples = (farmId: string | undefined) =>
  useQuery({
    queryKey: queryKeys.socSamples(farmId),
    queryFn: ({ signal }) => getSOCSamples({ farmId: farmId as string, signal }),
    enabled: !!farmId,
  })

// Both saves run inside the dialog's processLoading, which reports the failure itself.
const suppressGlobalError = { suppressGlobalError: true }

export const useCreateSOCSample = (farmId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createSOCSample,
    meta: suppressGlobalError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.socSamples(farmId) })
    },
  })
}

export const useUpdateSOCSample = (farmId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateSOCSample,
    meta: suppressGlobalError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.socSamples(farmId) })
    },
  })
}

export const useRemoveSOCSample = (farmId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: removeSOCSample,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.socSamples(farmId) })
    },
  })
}
